import { apiClient } from '@/lib/api'
import type {
  ConnectionWriteBody,
  FacebookCallback,
  FacebookConnectionBody,
  FacebookStart,
  IntegrationConnection,
  IntegrationPost,
  ManualPostBody,
} from '@/types/integrations'

// --- Connections ---

export const fetchConnections = () =>
  apiClient<IntegrationConnection[]>('/integrations/connections')

export const createConnection = (body: ConnectionWriteBody) =>
  apiClient<IntegrationConnection>('/integrations/connections', { method: 'POST', body })

export const updateConnection = (id: string, body: ConnectionWriteBody) =>
  apiClient<IntegrationConnection>(`/integrations/connections/${id}`, { method: 'PUT', body })

export const deleteConnection = (id: string) =>
  apiClient<void>(`/integrations/connections/${id}`, { method: 'DELETE' })

// --- Facebook connect flow ---

export const startFacebookConnect = () =>
  apiClient<FacebookStart>('/integrations/facebook/authorize/start')

// The SPA forwards the ?code/state Meta redirected back with (the redirect
// URI points at the settings page).
export const facebookCallback = (code: string, state: string) =>
  apiClient<FacebookCallback>('/integrations/facebook/callback', {
    method: 'POST',
    body: { code, state },
  })

export const createFacebookConnection = (body: FacebookConnectionBody) =>
  apiClient<IntegrationConnection>('/integrations/connections/facebook', { method: 'POST', body })

// --- Post log + manual posting ---

export const fetchIntegrationPosts = () => apiClient<IntegrationPost[]>('/integrations/posts')

export const fetchBoatPosts = (boatId: string) =>
  apiClient<IntegrationPost[]>(`/integrations/boats/${boatId}/posts`)

export const postBoatManually = (boatId: string, body: ManualPostBody) =>
  apiClient<IntegrationPost[]>(`/integrations/boats/${boatId}/post`, { method: 'POST', body })
